import script from "./GlobalStoreViewerWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./GlobalStoreViewerWidget.vue?vue&type=script&setup=true&lang=js"

import "./GlobalStoreViewerWidget.vue?vue&type=style&index=0&id=4be985a4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4be985a4"]])

export default __exports__